import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import {customersSlice} from "../app/modules/ECommerce/_redux/customers/customersSlice";
import {productsSlice} from "../app/modules/ECommerce/_redux/products/productsSlice";
import {remarksSlice} from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import {specificationsSlice} from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";
import {profileSlice} from "../app/modules/UserProfile/_redux/Profile/profileSlice"
import { activeOffersSlice } from "../app/modules/MyKorek/_redux/activeOffers/activeOffersSlice";
import { activeVasOffersSlice } from "../app/modules/MyKorek/_redux/activeVasOffers/activeVasOffersSlice";
import { topupMyAccountsSlice } from "../app/modules/MyKorek/_redux/topupMyAccounts/topupMyAccountsSlice";
import { rechargeLinesSlice } from "../app/modules/MyKorek/_redux/rechargeLines/rechargeLinesSlice";
import { myBillsSlice } from "../app/modules/MyKorek/_redux/myBills/myBillsSlice";
import { blueProgramSlice } from "../app/modules/MyKorek/_redux/blueProgram/blueProgramSlice";
import { internationalCallsSlice } from "../app/modules/Web/_redux/internationalCalls/internationalCallsSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
  activeOffers: activeOffersSlice.reducer,
  activeVasOffers: activeVasOffersSlice.reducer,
  profileSlice: profileSlice.reducer,
  topupMyAccounts:topupMyAccountsSlice.reducer,
  rechargeLines:rechargeLinesSlice.reducer,
  myBills:myBillsSlice.reducer,
  blueProgram:blueProgramSlice.reducer,
  internationalCalls:internationalCallsSlice.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
